import {Injectable} from '@angular/core';
import {UserService} from 'common-domain';
import {AuthService} from 'common-domain';
import {UserVO} from 'common-domain';
import {AppConfigService} from 'common-domain';

@Injectable({
  providedIn: 'root'
})
export class TermsAndPrivacyAcknowledgmentService {
  constructor(private userService: UserService, private authService: AuthService, private appConfigService: AppConfigService) {
  }

  get displayTermsAndPrivacyAcknowledgment(): boolean {
    const user: UserVO = this.authService.currentUserAuthVO();
    if (user === null) {
      return false;
    }
    if (user.termsAndPrivacyAcknowledgmentDate && user.loginName) { // case when signing up, do not display user agreement:
      return new Date(this.appConfigService.getTermsAndPrivacyVersion()) > new Date(user.termsAndPrivacyAcknowledgmentDate);
    }
    return true;
  }

  acknowledge(): void {
    const user: UserVO = this.authService.currentUserAuthVO();
    user.termsAndPrivacyAcknowledgmentDate = this.appConfigService.getTermsAndPrivacyVersion();
    localStorage.setItem('user', JSON.stringify(user));
    this.userService.acknowledgeTerms().subscribe(_ => {});
  }
}
